import React from 'react';

class TechnicalSupportChatView extends React.Component {
  render() {
    return (
      <div>
        <div className="row mb-4">
          <div className="col-12">
            <h1 className="text-vw-dark">CHAT DE SOPORTE TÉCNICO</h1>
          </div>
        </div>
        <hr className="bg-vw-light" />
        <div className="row">
          <div className="col-12">
            <p className="text-muted">Página de Chat próximamente disponible.</p>
          </div>
        </div>
      </div>
    );
  }
}

export default TechnicalSupportChatView;
